import { render } from "./Product.vue?vue&type=template&id=de5b2918&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=de5b2918&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de5b2918"]])

export default __exports__